import React, {memo} from "react"

import CircularProgress from "@mui/material/CircularProgress"
import classnames from "classnames"


import styles from "./index.module.scss"

const Loading = props => {
	let {color, value, className, classes = {}, children, ...rest} = props
	let progressStyle = color ? {color: color} : null
	return (
		<div
			{...rest}
			className={classnames(styles.root, className, classes.root)}
		>
			<CircularProgress
				style={progressStyle}
				className={styles.progress}
			/>
		</div>
	)
}

export default memo(Loading)
